import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getLiveChatEnabled = (configuration: IConfigurationParams[]): boolean => {
  const liveChatParams = configuration?.find((
    params,
  ) => params.name === ConfigurationNames.liveChat);

  return liveChatParams ? JSON.parse(liveChatParams.configuration).enabled : false;
};
